export default "__VITE_PUBLIC_ASSET__0b07d6ef__"